// extracted by mini-css-extract-plugin
module.exports = {"MenuIcon":"nav_MenuIcon__3xvi9","Brand":"nav_Brand__2tq4m"};